import {connect} from 'react-redux'
import {Link, withRouter} from 'react-router-dom'

import PageLayout from '../../containers/Layout/PageLayout.jsx'

import conf from '../../../shared/conf.js'
import {isArray} from "validate.js"

const mustBeLogged = function (Component, accountType = null) {
  let MustBeLoggedComponent = (props) => {
    const {currentUser, currentFreelance, loading, ...rest} = props

    if (loading) {
      return null
    }

    const offerViewableAsGuest = rest.offer && rest.offer.published && rest.offer.filled
    if (offerViewableAsGuest) {
      return <Component currentUser={currentUser} currentFreelance={currentFreelance} {...rest}/>
    }

    if (!currentUser && (null === rest.offer || !offerViewableAsGuest)) {
      return (
        <PageLayout>
          <h2 className="text-center">
            Impossible d'accéder à ce contenu
          </h2>
          <p className="text-center mb-5">
            Vous devez être connecté pour pouvoir accéder à cette page.
          </p>
          <p className="text-center">
            <Link
              className="btn btn-primary"
              to={{
                pathname: '/login',
                state: {redirectTo: props.location.pathname}
              }}
            >Se connecter</Link>
          </p>
        </PageLayout>
      )
    }

    const allowedAccountTypes = (accountType && isArray(accountType)) ? accountType: [accountType]

    const userAccountType = parseInt(currentUser.account_type, 10)
    const wantedAccountTypes = allowedAccountTypes.map((type) => (parseInt(type, 10)))

    if (
      (accountType && !wantedAccountTypes.includes(userAccountType)) ||
      (userAccountType === conf.accountTypes.freelance && !currentFreelance)
    ) {
      return (
        <PageLayout>
          <h2 className="text-center">
            Impossible d'accéder à ce contenu
          </h2>
          <p className="text-center mb-5">
            Vous ne possédez pas les bon privilèges pour accéder à ce contenu.
          </p>
          <p className="text-center">
            <button onClick={props.history.goBack} type="button" className="btn btn-primary">
              Retour
            </button>
          </p>
        </PageLayout>
      )
    }

    return <Component currentUser={currentUser} currentFreelance={currentFreelance} {...rest}/>
  }

  MustBeLoggedComponent = connect(
    state => ({
      currentFreelance: state.currentUser.freelance,
      currentUser: state.currentUser.user,
      loading: state.currentUser.loading
    })
  )(MustBeLoggedComponent)

  return withRouter(MustBeLoggedComponent)
}

export default mustBeLogged